import React, { useState } from "react";

type GroupProps = {
  title: string;
};

const Group: React.FC<GroupProps> = ({ children, title }) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div className="border border-dashed p-6 border-white border-opacity-30 rounded-2xl">
      <div className="flex items-center mb-5">
        <h3 className="text-lg mb-3 text-gray-100 box-border flex-grow">
          {title}
        </h3>
        <svg
          className="text-gray-50 cursor-pointer"
          fill="currentColor"
          width="28"
          height="28"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M0 0h24v24H0z"
            fill="none"
          ></path>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          ></path>
        </svg>
      </div>
      <div className="flex">
        <div className="flex-grow">{children}</div>
        <div
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          className="w-5 flex ml-4 rounded-xl relative bg-white bg-opacity-20"
        >
          {isHovering && (
            <div
              style={{
                right: "calc(100% + 5px)"
              }}
              className="absolute p-5 bg-gray-500 bg-opacity-100 top-1/3 z-50 rounded-xl bg-gradient-to-b from-blue-800 to-indigo-900 text-gray-50"
            >
              <div className="flex flex-col">
                <div className="flex items-center mb-3 font-semibold text-green-500">
                  <div className="mr-10 whitespace-nowrap flex-grow">
                    Tracked
                  </div>
                  <div className="text-right">15:13:00</div>
                </div>
                <div className="flex items-center mb-3">
                  <div className="mr-10 whitespace-nowrap flex-grow">
                    Remaining
                  </div>
                  <div className="text-right">75:00:00</div>
                </div>
                <div className="flex items-center mb-3">
                  <div className="mr-10 whitespace-nowrap flex-grow">
                    Current estimation
                  </div>
                  <div className="text-right">90:00:00</div>
                </div>
                <div className="flex items-center mb-3">
                  <div className="mr-10 whitespace-nowrap flex-grow">
                    First estimated
                  </div>
                  <div className="text-right">80:00:00</div>
                </div>
              </div>
            </div>
          )}

          <div
            style={{
              background:
                "linear-gradient(180deg, rgba(3, 255, 43, 0.26) 6.41%, rgba(3, 255, 43, 0) 100%)"
            }}
            className="absolute bottom-0 w-full h-2/3"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Group;
